var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Reopen Audit",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "800px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-width": "138px"
    }
  }, [_vm.engagementDetail.reopenStatus == 0 && _vm.engagementDetail.reopenReason ? _c('el-form-item', {
    attrs: {
      "label": "Reopen Reason"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.engagementDetail.reopenReason))])]) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Status",
      "prop": "reopenStatus"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.dataForm.reopenStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "reopenStatus", $$v);
      },
      expression: "dataForm.reopenStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("Rejected")]), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("Pass")])], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Remark"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }